/**
 * Login intro: muvaffaqiyatli kirishdan keyin FATH TIME logo animatsiyasi, so'ng platforma ochiladi.
 * Faqat yangi kirishda (sahifa yangilanganda chiqmaydi). Kirishni hech qachon to'smaydi: har bosqich vaqt bilan
 * o'zi tugaydi, logoni bosish yoki Esc bilan o'tkazib yuborsa bo'ladi.
 * Ko'rinish: components/brand/LoginIntro.tsx, platformaning ochilishi: AppShell (.app-reveal).
 */
import { useSyncExternalStore } from "react";

/** idle -- intro yo'q; logo -- logo animatsiyasi; reveal -- ko'k parda o'tadi va platforma ochiladi */
export type IntroPhase = "idle" | "logo" | "reveal";

/** Bosqichlar davomiyligi (ms). Logo vaqtlari Remotion'dagi FathTimeReveal bilan bir xil (my-video/src/fath-time) */
export const INTRO_MS = {
  logo: 2000,
  reveal: 1500,
  // Harakatni kamaytirish sozlamasi: logo harakatsiz, qisqa so'nish
  reducedLogo: 700,
  reducedReveal: 250,
} as const;

let phase: IntroPhase = "idle";
const listeners = new Set<() => void>();

function setPhase(next: IntroPhase) {
  if (phase === next) return;
  phase = next;
  listeners.forEach((l) => l());
}

export function getIntroPhase(): IntroPhase {
  return phase;
}

export function subscribeIntro(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useIntroPhase(): IntroPhase {
  return useSyncExternalStore(subscribeIntro, getIntroPhase, getIntroPhase);
}

/** Kirish muvaffaqiyatli bo'lganda (login yoki 2FA) chaqiriladi */
export function startLoginIntro() {
  setPhase("logo");
}

/** Keyingi bosqichga: logo -> reveal -> idle */
export function advanceIntro() {
  setPhase(phase === "logo" ? "reveal" : "idle");
}

/** Bosish yoki Esc: logoni o'tkazib, darhol platformani ochadi (ochilish o'zi to'xtatilmaydi) */
export function skipIntroLogo() {
  if (phase === "logo") setPhase("reveal");
}

export function introDuration(p: IntroPhase, reducedMotion: boolean): number {
  if (p === "logo") return reducedMotion ? INTRO_MS.reducedLogo : INTRO_MS.logo;
  if (p === "reveal") return reducedMotion ? INTRO_MS.reducedReveal : INTRO_MS.reveal;
  return 0;
}

export function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}
